function getCurrentUser() {
  try {
    const raw = localStorage.getItem('user');
    if (!raw) {
      return null;
    }

    const user = JSON.parse(raw);
    return {
      id: user.id || null,
      name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || null,
      email: user.officialEmail || user.email || null,
      department: user.Department || null,
      role: user.role || null,
    };
  } catch (_) {
    return null;
  }
}

function shouldReportAxiosError(error) {
  const status = error?.response?.status;
  const url = error?.config?.url || '';
  const ignoredEndpoints = [
    '/feedback/my-feedback/unread-replies',
  ];

  if (url.includes('/client-errors')) {
    return false;
  }

  if (ignoredEndpoints.some((endpoint) => url.includes(endpoint))) {
    return false;
  }

  return !status || status >= 500;
}

async function sendClientIncident(payload) {
  try {
    await fetch('/api/client-errors', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Client-Error-Report': 'true',
      },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
  } catch (error) {
    // Never break the app because reporting failed.
    console.error('Client error reporting failed:', error.message);
  }
}

export async function reportAxiosError(error) {
  if (!shouldReportAxiosError(error)) {
    return;
  }

  await sendClientIncident({
    type: 'axios',
    message: error.message || 'API request failed',
    route: window.location.pathname,
    user: getCurrentUser(),
    request: {
      url: error.config?.url || null,
      method: error.config?.method || null,
      status: error.response?.status || null,
      response: error.response?.data || null,
    },
    timestamp: new Date().toISOString(),
  });
}

export async function reportRuntimeError(error, metadata = {}) {
  await sendClientIncident({
    type: 'runtime',
    message: error?.message || 'Unhandled runtime error',
    route: window.location.pathname,
    user: getCurrentUser(),
    stack: error?.stack || null,
    metadata,
    timestamp: new Date().toISOString(),
  });
}

export function registerGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    reportRuntimeError(event.error || new Error(event.message), {
      source: 'window.onerror',
    });
  });

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason instanceof Error ? event.reason : new Error(String(event.reason));
    reportRuntimeError(reason, {
      source: 'window.onunhandledrejection',
    });
  });
}
